module.exports = __webpack_public_path__ + "img/5-6-2.5e7b019d.png";